import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  icon?: ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost' | 'quiet';
  size?: 'compact' | 'default' | 'field';
}

export function Button({
  children,
  className = '',
  icon,
  variant = 'primary',
  size = 'default',
  ...props
}: ButtonProps) {
  const iconOnly = children == null;
  return (
    <button
      className={`kop-button kop-button--${variant} kop-button--${size}${iconOnly ? ' kop-button--icon-only' : ''} ${className}`.trim()}
      {...props}
    >
      {icon ? (
        <span className="kop-button__icon" aria-hidden="true">
          {icon}
        </span>
      ) : null}
      {children != null ? <span>{children}</span> : null}
    </button>
  );
}
